<div *ngIf="!isInitialFormUser">
  <div class="relative-container border-outline col-1">
    <h3 *ngIf="!isProjectInput" class="outline-border-header" anessaTranslation="PROJECT.PROJECT_INFO.CHECKLIST.EXISTING_CHECKLISTS"></h3>
    <h3 *ngIf="isProjectInput" class="outline-border-header" anessaTranslation="PROJECT.INITIAL.INPUT_LIST.EXISTING_INPUTLISTS"></h3>
    <anessa-table
      [data]="checklists"
      [dataChangeNotifier]="dataChangeNotifier"
      [keys]="['name']"
      [customFields]="getLastModifiedArray()"
      [style]="'small'"
      [editIndex]="editIndex"
      [disableRemove]="readOnlyInitialChecklists || editOnlyInitialChecklists || isInitialFormUser"
      (onEdit)="onEditChecklist($event)"
      (onRemove)="onRemoveChecklist($event)"
    ></anessa-table>
    <div class="wrapped-button-container" *ngIf="!isInitialFormUser" style="justify-content: flex-start; margin-top: 25px;">
      <button
        mat-button
        class="wrapped-button"
        (click)="onAddChecklist()"
        [disabled]="readOnlyInitialChecklists || editOnlyInitialChecklists"
        anessaTranslation="{{getAddButtonLabel()}}">
      </button>
      <ng-container *ngIf="showFormButtons()">
        <!-- <button
          mat-button
          [disabled]="!(checklists?.length > 0 || checklistFormTemplates?.length > 0) || readOnlyInitialChecklists  || editOnlyInitialChecklists"
          class="wrapped-button"
          anessaTranslation="PROJECT.PROJECT_INFO.CHECKLIST.TEMPLATE.SAVE_AS_FORM_TEMPLATE"
          (click)="onSaveFormTemplate()">
        </button> -->
        <button
          mat-button
          [disabled]="!(checklists?.length > 0 || checklistFormTemplates?.length > 0) || readOnlyInitialChecklists  || editOnlyInitialChecklists"
          class="wrapped-button"
          anessaTranslation="PROJECT.PROJECT_INFO.CHECKLIST.TEMPLATE.LOAD_FORM_TEMPLATE"
          (click)="onLoadFormTemplateClick()">
        </button>
        <button
          mat-button
          [disabled]="!(checklists?.length > 0) || readOnlyInitialChecklists  || editOnlyInitialChecklists"
          class="wrapped-button"
          anessaTranslation="PROJECT.PROJECT_INFO.CHECKLIST.CONVERT_TO_FORM"
          (click)="onConvertToForm()">
        </button>
        <button
          mat-button
          [disabled]="!(checklists?.length > 0) || readOnlyInitialChecklists  || editOnlyInitialChecklists"
          class="wrapped-button"
          anessaTranslation="PROJECT.PROJECT_INFO.CHECKLIST.CONVERT_TO_TABS"
          (click)="onConvertToTabs()">
        </button>
      </ng-container>
    </div>
  </div>
</div>
